(function () {
  /**
   * Handlers
   */
  function encodeURI(obj) {
    var result = "";
    var splitter = "";
    if (typeof obj === "object") {
      Object.keys(obj).forEach(function (key) {
        result += splitter + key + "=" + encodeURIComponent(obj[key]);
        splitter = "&";
      });
    }
    return result;
  }

  /**
   * Render
   * 
   * TODO: Refactor CALENDAR_ID so that this can detect and be used with any calendar ID.
   */
  setTimeout(function () {
    let { ajax_url, post_count, posts, sanitized_posts, last_day_of_month } =
      plugin_name_ajax_object;

    const CALENDAR_ID = "simple_calendar";

    let thisCalendar = document.querySelector(`#${CALENDAR_ID}`);
    if (thisCalendar === null) return;
    if (!thisCalendar) {
      return;
    }

    let scheduledEvents = [];
    const currentYear = moment().year();
    const endOfYear = moment().year(2065).endOf('year');

    sanitized_posts.forEach((event) => {
      let {
        event_id,
        event_start_date,
        event_end_date,
        is_event_all_day,
        event_start_time,
        event_end_time,
        event_recurrence,
        event_repeat_every,
        event_repeat_every_type,
        event_repeat_on_days,
        event_repeat_on_month_day,
        event_ends,
        event_ends_on_date,
        event_ends_after,
        event_color,
        categories,
        img,
        title,
        excerpt,
        permalink,
        long_excerpt
      } = event;

      let admission = moment(event_start_date, "YYYY-MM-DD");
      let endDate = moment(event_end_date, "YYYY-MM-DD");
      let discharge;

      if (event_ends_after) {
        discharge = moment.min(moment(event_ends_after, "YYYY-MM-DD"), endOfYear);
      } else if (event_ends === "never") {
        discharge = endOfYear;
      } else {
        discharge = event_ends_on_date ? moment.min(moment(event_ends_on_date, "YYYY-MM-DD"), endOfYear) : endOfYear;
      }

      if (!admission.isValid() || !endDate.isValid()) {
        console.error("Invalid admission or end date:", event_start_date, event_end_date);
        return;
      }

      if (discharge && !discharge.isValid()) {
        console.error("Invalid discharge date:", event_ends_after || event_ends_on_date);
        return;
      }

      let additional_fields = {};
      if (event_start_time !== undefined && event_end_time !== undefined) {
        additional_fields = {
          ...additional_fields,
          time: {
            start_time: event_start_time,
            end_time: event_end_time,
          },
        };
      }

      let events = [];

      const addEventForDate = (date) => {
        events.push({
          id: event_id,
          permalink: permalink,
          title: title,
          eventCategories: categories,
          img: img,
          excerpt: excerpt,
          long_excerpt: long_excerpt,
          date: date.format("YYYY-MM-DD"),
          dateObj: {
            start_date: event_start_date,
            end_date: event_end_date,
          },
          color: event_color,
          repeated: event_recurrence !== 'no_repeat',
          ...additional_fields,
        });
      };

      if (event_recurrence === 'no_repeat') {
        for (let d = 0; d <= endDate.diff(admission, 'days'); d++) {
          addEventForDate(admission.clone().add(d, 'days'));
        }
      } else {
        let currentDay = admission.clone();

        const addRecurringEvents = (interval) => {
          while (currentDay.isSameOrBefore(discharge)) {
            for (let d = 0; d <= endDate.diff(admission, 'days'); d++) {
              addEventForDate(currentDay.clone().add(d, 'days'));
            }
            currentDay.add(interval, 'days');
          }
        };

        if (event_recurrence === 'daily') {
          addRecurringEvents(1);
        } else if (event_recurrence === 'weekly') {
          addRecurringEvents(7);
        } else if (event_recurrence === 'monthly') {
          let nthWeekday = Math.ceil(admission.date() / 7);
          let dayOfWeek = admission.day();

          while (currentDay.isSameOrBefore(discharge)) {
            let targetDay;

            if (nthWeekday === 1) {
              targetDay = currentDay.clone().startOf('month').isoWeekday(dayOfWeek);
              if (targetDay.date() > 7) {
                targetDay.add(1, 'week');
              }
            } else {
              targetDay = currentDay.clone().startOf('month').add(nthWeekday - 1, 'weeks').isoWeekday(dayOfWeek);

              if (targetDay.month() !== currentDay.month()) {
                targetDay = currentDay.clone().endOf('month').isoWeekday(dayOfWeek);
                if (targetDay.month() !== currentDay.month()) {
                  targetDay.subtract(7, 'days');
                }
              }
            }

            if (nthWeekday > 1 && targetDay.date() < admission.date()) {
              targetDay.add(1, 'weeks');
            }

            if (targetDay.month() !== currentDay.month()) {
              targetDay = currentDay.clone().endOf('month').isoWeekday(dayOfWeek);
              if (targetDay.month() !== currentDay.month()) {
                targetDay.subtract(7, 'days');
              }
            }

            if (targetDay.isSameOrBefore(discharge) && targetDay.isSameOrAfter(admission)) {
              for (let d = 0; d <= endDate.diff(admission, 'days'); d++) {
                addEventForDate(targetDay.clone().add(d, 'days'));
              }
            }

            currentDay.add(1, 'month');
          }
        } else if (event_recurrence === 'annually') {
          while (currentDay.isSameOrBefore(discharge)) {
            for (let d = 0; d <= endDate.diff(admission, 'days'); d++) {
              addEventForDate(currentDay.clone().add(d, 'days'));
            }
            currentDay.add(1, 'year');
          }
        } else if (event_recurrence === 'every_weekday') {
          while (currentDay.isSameOrBefore(discharge)) {
            if (currentDay.isoWeekday() < 6) {
              for (let d = 0; d <= endDate.diff(admission, 'days'); d++) {
                addEventForDate(currentDay.clone().add(d, 'days'));
              }
            }
            currentDay.add(1, 'day');
          }
        } else if (event_recurrence === 'custom') {
          let repeatInterval = event_repeat_every;
          let repeatType = event_repeat_every_type;

          if (repeatType === 'week') {
            repeatInterval *= 7;
          } else if (repeatType === 'month') {
            repeatInterval = 1;
          } else if (repeatType === 'year') {
            repeatInterval *= 365;
          }

          if (repeatType === 'month' && event_repeat_on_month_day === 'nth_weekday') {
            let nthWeekday = Math.ceil(admission.date() / 7);
            let dayOfWeek = admission.day();

            while (currentDay.isSameOrBefore(discharge)) {
              let targetDay;

              if (nthWeekday === 1) {
                targetDay = currentDay.clone().startOf('month').isoWeekday(dayOfWeek);
                if (targetDay.date() > 7) {
                  targetDay.add(1, 'week');
                }
              } else {
                targetDay = currentDay.clone().startOf('month').add(nthWeekday - 1, 'weeks').isoWeekday(dayOfWeek);

                if (targetDay.month() !== currentDay.month()) {
                  targetDay = currentDay.clone().endOf('month').isoWeekday(dayOfWeek);
                  if (targetDay.month() !== currentDay.month()) {
                    targetDay.subtract(7, 'days');
                  }
                }
              }

              if (nthWeekday > 1 && targetDay.date() < admission.date()) {
                targetDay.add(1, 'weeks');
              }

              if (targetDay.month() !== currentDay.month()) {
                targetDay = currentDay.clone().endOf('month').isoWeekday(dayOfWeek);
                if (targetDay.month() !== currentDay.month()) {
                  targetDay.subtract(7, 'days');
                }
              }

              if (targetDay.isSameOrBefore(discharge) && targetDay.isSameOrAfter(admission)) {
                for (let d = 0; d <= endDate.diff(admission, 'days'); d++) {
                  addEventForDate(targetDay.clone().add(d, 'days'));
                }
              }

              currentDay.add(1, 'month');
            }
          } else if (repeatType === 'month' && event_repeat_on_month_day === 'specific_day') {
            while (currentDay.isSameOrBefore(discharge)) {
              let targetDay = currentDay.clone().date(admission.date());
              if (targetDay.date() !== admission.date()) {
                targetDay = currentDay.clone().endOf('month');
              }

              if (targetDay.isSameOrBefore(discharge) && targetDay.isSameOrAfter(admission)) {
                for (let d = 0; d <= endDate.diff(admission, 'days'); d++) {
                  addEventForDate(targetDay.clone().add(d, 'days'));
                }
              }

              currentDay.add(1, 'month');
            }
          } else {
            event_repeat_on_days.forEach(day => {
              let currentDay = admission.clone().isoWeekday(day);

              while (currentDay.isSameOrBefore(discharge)) {
                for (let d = 0; d <= endDate.diff(admission, 'days'); d++) {
                  addEventForDate(currentDay.clone().add(d, 'days'));
                }
                currentDay.add(repeatInterval, 'days');
              }
            });
          }
        }
      }

      scheduledEvents.push(...events);
    });

    thisCalendar.eventList.addScheduledEvents(scheduledEvents);



  }, 400);
})();
